import { getCustomQueries } from "@/helpers/queryHelper";
import {
    CLEAR_ALL_ORDER_ITEM,
    CLEAR_PAYMENT_DATA,
    CLEAR_PAYMENT_QUERY,
    CLEAR_SINGLE_ORDER_ITEM,
    PAYMENT_FAILED,
    PAYMENT_REQUEST,
    PAYMENT_SUCCEEDED,
    PURCHASE_HISTORY_FAILED,
    PURCHASE_HISTORY_REQUEST,
    PURCHASE_HISTORY_SUCCEEDED,
    SET_ORDER_DATA,
    SET_PAYMENT_EDIT_DATA,
    SET_PAYMENT_QUERY_DATA
} from ".";

export const paymentRequest = ({ data }) => {
    return {
        type: PAYMENT_REQUEST,
        payload: {
            data,
            url: 'payment/',
            onSuccess: PAYMENT_SUCCEEDED,
            onFailure: PAYMENT_FAILED,
        },
    };
}

export const purchaseHistoryRequest = ({ data }) => {
    let query = getCustomQueries(data);
    return {
        type: PURCHASE_HISTORY_REQUEST,
        payload: {
            url: `purchase-history?${query}`,
            onSuccess: PURCHASE_HISTORY_SUCCEEDED,
            onFailure: PURCHASE_HISTORY_FAILED,
        }
    }
}

export const setOrderData = (payload) => {
    return {
        type: SET_ORDER_DATA,
        payload
    }
}

export const setPaymentEditData = (payload) => {
    return {
        type: SET_PAYMENT_EDIT_DATA,
        payload
    }
}

export const setPaymentQuerytData = (payload) => {
    return {
        type: SET_PAYMENT_QUERY_DATA,
        payload
    }
}

export const clearPaymentQuery = () => {
    return {
        type: CLEAR_PAYMENT_QUERY,
    }
}

export const clearSingleItem = (payload) => {
    return {
        type: CLEAR_SINGLE_ORDER_ITEM,
        payload
    }
}

export const clearAllItem = () => {
    return {
        type: CLEAR_ALL_ORDER_ITEM,
    }
}

export const clearPaymentData = () => {
    return {
        type: CLEAR_PAYMENT_DATA
    }
}